<template>
    <div class="container">
        <div class="items">
            <div class="item">item01</div>
            <div class="item">item02</div>
            <div class="item">item03</div>
            <div class="item">item04</div>
            <div class="item">item05</div>
            <div class="item">item06</div>
            <div class="item">item07</div>
            <div class="item">item08</div>
            <div class="item">item09</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "app"
    }
</script>

<style lang="scss" scoped>
    $item-bg: #a0d8ef;

    html {
        height: 100%;
        width: 100%;

        body {
            height: 100%;
            margin: 0;
            padding: 0;
            position: relative;
            text-align: center;
            width: 100%;

            .items {
                left: 50%;
                position: absolute;
                top: 50%;
                transform: translateY(-50%) translateX(-50%);
                width: 330px;
            }

            .item {
                animation: 1s ease 0s pulse infinite;
                background: $item-bg;
                border-radius: 4px;
                float: left;
                height: 75px;
                margin: 5px;
                width: 100px;
                text-align: center;
            }
        }
    }

    @for $i from 1 through 9 {
        .item {
            &:nth-child(#{$i}) {
                animation-delay: $i * (1s / 18);
            }
        }
    }

    @keyframes pulse {
        0% {
            background: $item-bg;
            transform: scale(1);
        }
        25% {
            background: darken($item-bg, 10%);
            transform: scale(1.015);
        }
        50% {
            background: $item-bg;
            transform: scale(1);
        }
    }
</style>